export const getTitleText = (pickerName: string) => pickerName;
